import { render, staticRenderFns } from "./VolunteerThankYou.vue?vue&type=template&id=088868a0&scoped=true"
import script from "./VolunteerThankYou.vue?vue&type=script&lang=ts"
export * from "./VolunteerThankYou.vue?vue&type=script&lang=ts"
import style0 from "./VolunteerThankYou.vue?vue&type=style&index=0&id=088868a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088868a0",
  null
  
)

export default component.exports